import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material-module';
import { NavListComponent } from './nav-list/nav-list.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from '../core/auth/token-interceptor';


@NgModule({
  declarations: [MenuComponent,NavListComponent],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
  ],
  providers:[{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  }]
})
export class MenuModule { }
